export async function getItems() {
    const res = await fetch(`api/NekomimiSitter/EventList`);
    const json = await res.json();
    if (!res.ok) throw new Error(json.message);
    return json;
}
